import Projects from "../components/PrivateProjectPage.js";
import { useParams } from "react-router-dom";
import { useRef } from "react";
import portfolioSlideData from "../databases/privatePortfolioSlideData.json";
import { CSSTransition } from "react-transition-group";

const PrivateProjectWrapper = () => {
  const nodeRef = useRef(null);
  const { projectID } = useParams(); // Grabs "garden-demo-2026" from URL

  // Find the specific project object that matches the ID in the URL
  const currentProject = portfolioSlideData.find((p) => p.id === projectID);

  // 404 Guard: If the ID in the URL doesn't exist in your JSON
  if (!currentProject) {
    return (
      <div style={{ color: "white", textAlign: "center", paddingTop: "100px" }}>
        <h2>Project Not Found</h2>
        <p>The private link you are using may be incorrect.</p>
      </div>
    );
  }

  return (
    // We keep CSSTransition, though without 'prev/next' it only triggers on initial load
    <CSSTransition
      nodeRef={nodeRef}
      in={true}
      appear={true}
      timeout={200}
      classNames="my-node"
    >
      <div ref={nodeRef}>
        <Projects
          videoUrl={currentProject.videoURL}
          image1Url={currentProject.image1URL}
          image2Url={currentProject.image2URL}
          image3Url={currentProject.image3URL}
          audioPlayerPath={currentProject.audioPlayerPath}
          directedBy={<div>{currentProject.directedBy}</div>}
          projectPara1={<div>{currentProject.projectPara1}</div>}
          projectPara2={<div>{currentProject.projectPara2}</div>}
          projectPara3={<div>{currentProject.projectPara3}</div>}
          projectTitle={currentProject.title}
          trackArray={currentProject.tracks}
          multitrack={currentProject.multitrack}
          // Navigation props removed as they are no longer needed
        />
      </div>
    </CSSTransition>
  );
};

export default PrivateProjectWrapper;
